// =============================================================================
// FILE PATH : src/modules/pms/task_template/components/TaskItemGrid.js
// MODULE    : PMS → Task Template
// PURPOSE   : Dynamic task row editor inside template form
// =============================================================================

import React from "react";
import { TASK_CATEGORIES, DEFAULT_TASK_ITEM } from "../constants/taskTemplateConstants";


const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "10px"
};

const thStyle = {
  textAlign: "left",
  padding: "10px",
  background: "#f5f5f5",
  borderBottom: "1px solid #ddd",
  fontSize: "13px"
};

const tdStyle = {
  padding: "8px",
  borderBottom: "1px solid #eee"
};

const inputStyle = {
  width: "100%",
  padding: "6px 8px",
  borderRadius: "4px",
  border: "1px solid #ccc"
};

const buttonStyle = {
  marginTop: "10px",
  padding: "8px 12px",
  border: "none",
  borderRadius: "6px",
  background: "#1976d2",
  color: "#fff",
  cursor: "pointer"
};


const TaskItemGrid = ({ items, setItems }) => {

  // ---------------------------------------------------------------------------
  // HANDLE FIELD CHANGE
  // ---------------------------------------------------------------------------
  const handleChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  // ---------------------------------------------------------------------------
  // ADD NEW ROW
  // ---------------------------------------------------------------------------
  const addRow = () => {
    const newItem = {
      ...DEFAULT_TASK_ITEM,
      sequence_no: items.length + 1
    };
    setItems([...items, newItem]);
  };

  // ---------------------------------------------------------------------------
  // DELETE ROW
  // ---------------------------------------------------------------------------
  const deleteRow = (index) => {
    const updated = items.filter((_, i) => i !== index);

    // Recalculate sequence
    updated.forEach((item, idx) => {
      item.sequence_no = idx + 1;
    });

    setItems(updated);
  };

  return (
    <div>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Task Name</th>
            <th style={thStyle}>Category</th>
            <th style={thStyle}>Duration</th>
            <th style={thStyle}>Seq</th>
            <th style={thStyle}></th>
          </tr>
        </thead>

        <tbody>
          {items.map((item, index) => (
            <tr key={index}>

              {/* TASK NAME */}
              <td style={tdStyle}>
                <input
                  type="text"
                  value={item.task_name}
                  onChange={(e) =>
                    handleChange(index, "task_name", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="Enter task name"
                />
              </td>

              {/* CATEGORY */}
              <td style={tdStyle}>
                <select
                  value={item.task_category}
                  onChange={(e) =>
                    handleChange(index, "task_category", e.target.value)
                  }
                  style={inputStyle}
                >
                  {TASK_CATEGORIES.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              </td>

              {/* DURATION */}
              <td style={tdStyle}>
                <input
                  type="number"
                  value={item.default_duration || ""}
                  onChange={(e) =>
                    handleChange(index, "default_duration", e.target.value)
                  }
                  style={inputStyle}
                  min="1"
                />
              </td>

              {/* SEQUENCE */}
              <td style={tdStyle}>
                <input
                  type="number"
                  value={item.sequence_no}
                  onChange={(e) =>
                    handleChange(index, "sequence_no", e.target.value)
                  }
                  style={inputStyle}
                  min="1"
                />
              </td>

              {/* DELETE */}
              <td style={tdStyle}>
                <button
                  onClick={() => deleteRow(index)}
                  style={{
                    border: "none",
                    background: "transparent",
                    color: "#d32f2f",
                    cursor: "pointer"
                  }}
                >
                  ❌
                </button>
              </td>

            </tr>
          ))}
        </tbody>
      </table>

      {/* ADD BUTTON */}
      <button onClick={addRow} style={buttonStyle}>
        + Add Task
      </button>

    </div>
  );
};

export default TaskItemGrid;